// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec0c9960","455":"64934c4e","977":"615e7963"}[chunkId] + ".chunk.js";
};